
export const siteNavigationComponent = () => {

    console.log("site navi init");

    var sub_menu_item = jQuery('.sub-menu > li');
    sub_menu_item.prepend('<div class="submenu-item-dot"></div>');

    var item_with_child = jQuery('.menu-item-has-children > a');
    var site_navi_wrapper = jQuery('.site-navigation-wrapper');
    var sub_menu_wrapper = jQuery(".site-navigation-sub-wrapper");

    item_with_child.click( function(e) {

        var clicked_item = jQuery(this);
        var rel_sub_menu = jQuery(this).parent().find('.sub-menu');  
        var sub_menu_height = rel_sub_menu.height() + 40;
        var rel_chevron = jQuery(this).parent().find('.chevron-submenu > svg');

        e.preventDefault();        

        if (site_navi_wrapper.attr('data-visibility') == 'hidden') {
            
            console.log("Show the Submenu");
            // Show the Submenu
            site_navi_wrapper.attr('data-visibility', 'visible');
            sub_menu_wrapper.animate({
                'height': sub_menu_height,
            }, 80);

            rel_sub_menu.addClass("active");
            clicked_item.addClass("active");
            rel_chevron.addClass("chevron-active");

        } else {

            if (clicked_item.is(".active")) {

                console.log("Hide the Submenus");
                // Hide the Submenus
                site_navi_wrapper.attr('data-visibility', 'hidden');
                sub_menu_wrapper.animate({
                    'height': '0',
                }, 250);
                rel_sub_menu.removeClass("active");
                clicked_item.removeClass("active");
                rel_chevron.removeClass("chevron-active");


            } else {

                console.log("Update the Submenu");
                // Update the Submenu
                site_navi_wrapper.attr('data-visibility', 'visible');
                sub_menu_wrapper.animate({
                    'height': sub_menu_height,
                }, 100);

                jQuery('.chevron-submenu > svg').removeClass("chevron-active");;
                jQuery('.sub-menu').removeClass("active");
                jQuery('.menu-item-has-children > a').removeClass("active");

                rel_sub_menu.addClass("active");
                clicked_item.addClass("active");
                rel_chevron.addClass("chevron-active");

            }

        }
    })

    jQuery(".site-main, .hero-wrapper, .site-modules").on('click', function () {
        
        // Hide the Submenus
        site_navi_wrapper.attr('data-visibility', 'hidden');
        sub_menu_wrapper.animate({
            'height': '0',
        }, 250);
        jQuery('.sub-menu').removeClass("active");
        jQuery('.menu-item-has-children > a').removeClass("active");


    })

    var toggle_button = document.querySelector('.menu-toggle');
    var main_navigation = document.querySelector('.main-navigation');

    toggle_button.onclick = function () {
        main_navigation.classList.toggle('active');
    }

    var btn_span = jQuery('#button-text');
    var btn_wrapper = jQuery('.button-wrapper');
    var video_wrapper = jQuery('.video-wrapper');
    var hamburger = jQuery('.button-wrapper button');

    btn_wrapper.on('click', function () {

        if (btn_span.is('.active')) {
            btn_span.removeClass('active');
            hamburger.removeClass('is-active');
            //btn_span.text("menu");

        } else {
            btn_span.addClass('active');
            hamburger.addClass('is-active');
            //btn_span.text("schließen");
        }

    })



}
